function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import { useState, useEffect } from "react";
var cachedScripts = {};
function useScript(src, options) {
    var _options;
    // Keeping track of script loaded and error state
    var _useState = _sliced_to_array(useState({
        loaded: false,
        error: false,
        errorDetails: null
    }), 2), state = _useState[0], setState = _useState[1];
    useEffect(function() {
        // If cachedScripts array already includes src that means another instance ...
        // ... of this hook already loaded this script, so no need to load again.
        if (cachedScripts[src]) {
            if (cachedScripts[src].loaded) {
                setState({
                    loaded: true,
                    error: false,
                    errorDetails: null
                });
                return;
            }
            cachedScripts[src].loadingPromise.then(function() {
                cachedScripts[src].loaded = true;
                setState({
                    loaded: true,
                    error: false,
                    errorDetails: null
                });
            }).catch(function(error) {
                setState({
                    loaded: false,
                    error: true,
                    errorDetails: error
                });
            });
            return;
        }
        var loadingPromise = new Promise(function(resolve, reject) {
            var _options;
            // Create script
            var script = document.createElement("script");
            script.src = src;
            script.async = true;
            if ((_options = options) == null ? void 0 : _options.attr) {
                var _options1;
                // eslint-disable-next-line no-restricted-syntax
                for(var _i = 0, _Object_entries = Object.entries((_options1 = options) == null ? void 0 : _options1.attr); _i < _Object_entries.length; _i++){
                    var _Object_entries__i = _sliced_to_array(_Object_entries[_i], 2), key = _Object_entries__i[0], value = _Object_entries__i[1];
                    script.setAttribute(key, value || "");
                }
            }
            var onScriptLoad = function() {
                cachedScripts[src].loaded = true;
                setState({
                    loaded: true,
                    error: false,
                    errorDetails: null
                });
                resolve();
            };
            var onScriptError = function(error) {
                delete cachedScripts[src];
                setState({
                    loaded: false,
                    error: true,
                    errorDetails: error
                });
                reject();
            };
            script.addEventListener("load", onScriptLoad);
            script.addEventListener("error", onScriptError);
            // Add script to document body
            document.body.appendChild(script);
        });
        if (!cachedScripts[src]) {
            cachedScripts[src] = {
                loaded: false,
                loadingPromise: loadingPromise
            };
        }
    }, [
        src,
        (_options = options) == null ? void 0 : _options.attr
    ] // Only re-run effect if script src changes
    );
    return [
        state.loaded,
        state.error,
        state.errorDetails
    ];
}
export default useScript;

//# sourceMappingURL=useScript.js.map